/*
 * Module for the benefit picker control
*/
rs.module("ui/controls/benefitpicker",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;

        var _menuToggle;
        var _benefitPicker;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;

            _benefitPicker = $.js(_jsSelectors.benefitPicker);
            _menuToggle = _benefitPicker.js(_jsSelectors.menuToggle);

            var benefitLinks = _benefitPicker.js(_jsSelectors.benefitLink, { multiple: true });

            // Close picker menu when user clicks outside of it
            $(document).click(function (e) {
                if (!_benefitPicker.is(e.target) && !_benefitPicker[0].contains(e.target)) {
                    toggleMenu(false);
                }
            })

            // Show menu when toggle is clicked
            _menuToggle.click(function () { toggleMenu(true); });

            // Update toggle text with the new benefit type and effective date when a new benefit is selected
            benefitLinks.click(function (event) {

                var selectedBenefitText = `${$(this).data("benefittype")} - ${$(this).data("benefiteffectivedate")}`;
                _menuToggle.js(_jsSelectors.toggleText).text(selectedBenefitText);

                toggleMenu(false);
            });

            // close the menu when focus is tabbed out of the benefit menu
            benefitLinks.last().on("tabforward", function (e) {
                toggleMenu(false);
            });
        }

        //
        // Toggle the visibilty of the menu
        //
        function toggleMenu(open) {
            _benefitPicker.toggleClass(_cssClasses.open, open);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);